import * as Actions from '../Actions/ModeloActions';

const initialState = {
    info: null,
    warning: null,
    error: null,
    pastas: null,
    meusmodelos: null
};

const ModeloReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.MODELO_INFO:
            {
                return {
                    ...state,
                    info: action.payload,
                };
            }
        case Actions.MODELO_WARNING:
            {
                return {
                    ...state,
                    warning: action.payload,
                };
            }
        case Actions.MODELO_ERROR:
            {
                return {
                    ...state,
                    error: action.payload,
                };
            }
        case Actions.GET_MODELOS: {
            return {
                ...state,
                meusmodelos: action.payload,
            };
        }
        default:
            {
                return state;
            }
    }
};

export default ModeloReducer;
